import { ListComponent } from "./List";
import { ShowComponent } from "./Show";

const components = {
  list: ListComponent,
  show: ShowComponent
}

export default components;